import { useTranslation } from 'react-i18next';

export const useTechSavviness = () => {
  const { t } = useTranslation();
  return [
    {
      value: 'LOW',
      label: t('participants.enums.techSavviness.low'),
    },
    {
      value: 'AVERAGE',
      label: t('participants.enums.techSavviness.average'),
    },
    {
      value: 'ADVANCED',
      label: t('participants.enums.techSavviness.advanced'),
    },
  ];
};
